import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = 'https://aaktradex.in';

const C = {
  green: '#3B6D11', lgreen: '#EAF3DE', bgreen: '#C0DD97',
  amber: '#854F0B', lamber: '#FAEEDA', bamber: '#FAC775',
  red:   '#A32D2D', lred:   '#FCEBEB', bred:   '#F7C1C1',
  blue:  '#185FA5', lblue:  '#E6F1FB', bblue:  '#B5D4F4',
  purple:'#6B21A8', lpurple:'#F3E8FF', bpurple:'#C4B5FD',
  teal:  '#0D7377', lteal:  '#E0F2F1', bteal:  '#80CBC4',
  gray:  '#6B7280', lgray:  '#F3F4F6', bgray:  '#D1D5DB',
};

function fmtRs(n) {
  if (n == null) return '—';
  const sign = n >= 0 ? '+' : '';
  return `${sign}Rs${Math.round(n).toLocaleString('en-IN')}`;
}

function fmtRsNoSign(n) {
  if (n == null) return '—';
  return `Rs${Math.round(n).toLocaleString('en-IN')}`;
}

function Card({ label, value, color, subvalue }) {
  return (
    <div style={{ padding: 10, background: 'var(--bg2)', borderRadius: 8, flex: 1 }}>
      <div style={{ fontSize: 9, color: 'var(--t2)', letterSpacing: 0.4 }}>{label}</div>
      <div style={{ fontSize: 15, fontWeight: 700, color, marginTop: 2 }}>{value}</div>
      {subvalue && (
        <div style={{ fontSize: 9, color: 'var(--t3)', marginTop: 2 }}>{subvalue}</div>
      )}
    </div>
  );
}

export default function LifetimeStats() {
  const [plData, setPlData] = useState(null);
  const [trailbData, setTrailbData] = useState(null);

  const fetchAll = useCallback(async () => {
    try {
      const [pl, tb] = await Promise.all([
        axios.get(`${API}/pl/lifetime`).catch(() => ({ data: null })),
        axios.get(`${API}/trailb/lifetime`).catch(() => ({ data: null })),
      ]);
      setPlData(pl.data);
      setTrailbData(tb.data);
    } catch (e) {
      console.error('Lifetime fetch:', e);
    }
  }, []);

  useEffect(() => {
    fetchAll();
    const t = setInterval(fetchAll, 30000);
    return () => clearInterval(t);
  }, [fetchAll]);

  if (!plData && !trailbData) return null;

  return (
    <div style={{
      display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: 12, marginBottom: 16,
    }}>
      {/* PL Trailblazers Lifetime */}
      {plData && (
        <div style={{
          background: 'var(--bg1)', border: `1px solid ${C.bpurple}`,
          borderRadius: 10, padding: 14,
        }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: C.purple, marginBottom: 8 }}>
            PL TRAILBLAZERS — LIFETIME (Real Money)
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            <Card
              label="REALIZED (all cycles)"
              value={fmtRs(plData.lifetime_realized)}
              color={plData.lifetime_realized >= 0 ? C.green : C.red}
              subvalue={`${plData.cycles_count} cycles · ${plData.positions_closed_lifetime} positions`}
            />
            <Card
              label="OPEN (this cycle)"
              value={fmtRs(plData.current_cycle_unrealized)}
              color={plData.current_cycle_unrealized >= 0 ? C.green : C.red}
            />
            <Card
              label="LIFETIME NET"
              value={fmtRs(plData.lifetime_net_including_open)}
              color={plData.lifetime_net_including_open >= 0 ? C.green : C.red}
            />
          </div>
        </div>
      )}

      {/* TrailB Active Lifetime */}
      {trailbData && (
        <div style={{
          background: 'var(--bg1)', border: `1px solid ${C.bblue}`,
          borderRadius: 10, padding: 14,
        }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: C.blue, marginBottom: 8 }}>
            TRAILB ACTIVE — LIFETIME (Paper Mode)
          </div>
          <div style={{ display: 'flex', gap: 6 }}>
            <Card
              label="REALIZED (closed trades)"
              value={fmtRs(trailbData.lifetime_realized_net)}
              color={trailbData.lifetime_realized_net >= 0 ? C.green : C.red}
              subvalue={`${trailbData.closed_trades_lifetime} closed · WR ${trailbData.win_rate_pct}%`}
            />
            <Card
              label="UNREALIZED (open now)"
              value={fmtRs(trailbData.current_unrealized_net)}
              color={trailbData.current_unrealized_net >= 0 ? C.green : C.red}
              subvalue={`${trailbData.open_trades_now} open`}
            />
            <Card
              label="LIFETIME NET"
              value={fmtRs(trailbData.lifetime_net_including_open)}
              color={trailbData.lifetime_net_including_open >= 0 ? C.green : C.red}
            />
          </div>
        </div>
      )}


    </div>
  );
}
